export const Routing = {
  home: '/',
  courses: '/courses',
  termsOfUse: '/terms-of-use',
  privacyStatement: '/privacy-statement',
  dsa: '/dsa',
  invitation: '/invitations/:invitationId',
  organization: '/organizations/:organizationId',
  course: '/organizations/:organizationId/courses/:courseId',
  documents: '/organizations/:organizationId/courses/:courseId/documents',
  document: '/organizations/:organizationId/courses/:courseId/documents/:documentId',
  courseChat: '/organizations/:organizationId/courses/:courseId/chat',
  courseEdit: '/organizations/:organizationId/courses/:courseId/edit',
  courseCustomizeAssistant: '/organizations/:organizationId/courses/:courseId/customize-assistant',
  courseEditConversationStarters: '/organizations/:organizationId/courses/:courseId/conversation-starters',
  courseStudents: '/organizations/:organizationId/courses/:courseId/students',
  courseChats: '/organizations/:organizationId/courses/:courseId/chats',
  courseChatView: '/organizations/:organizationId/courses/:courseId/chats/:chatId',
  surveyMslq: '/survey/mslq',
  admin: '/admin',
  invitations: 'invitations',
  organizations: 'organizations'
}

export * as GoSchool from './routes'



